import { BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import type { Ratebook } from '@api/useFreight/types'
import { invoiceGroupingMap } from '../../Customer/cellRenderers'

interface BillingInfoProps {
  ratebook: Ratebook
}

export function BillingInfo({ ratebook }: BillingInfoProps) {
  const displayGroupingValue = ratebook.invoice_configuration
    ? invoiceGroupingMap[ratebook.invoice_configuration.invoice_grouping as keyof typeof invoiceGroupingMap] ||
      ratebook.invoice_configuration.invoice_grouping
    : 'None'

  return (
    <Horizontal flex={2} justifyContent='space-between' gap={24} verticalCenter>
      <Vertical gap={4}>
        <Texto appearance='hint'>Billing Method</Texto>
        <BBDTag>{ratebook.invoice_configuration?.billing_volume_basis || 'N/A'}</BBDTag>
      </Vertical>
      <Vertical gap={4}>
        <Texto appearance='hint'>Billing Frequency</Texto>
        <BBDTag>{ratebook.invoice_configuration?.billing_frequency || 'N/A'}</BBDTag>
      </Vertical>
      <Vertical gap={4}>
        <Texto appearance='hint'>Terms</Texto>
        <BBDTag>{ratebook.invoice_configuration?.invoice_terms?.name || 'N/A'}</BBDTag>
      </Vertical>
      <Vertical gap={4}>
        <Texto appearance='hint'>Invoice Grouping</Texto>
        <BBDTag>{displayGroupingValue}</BBDTag>
      </Vertical>
    </Horizontal>
  )
}
